import '@forest/shared/polyfills'

import './setup'

import { QueryClientProvider } from '@tanstack/react-query'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { ErrorBoundary } from 'react-error-boundary'
import '~/styles/global.css'
import { App } from './app'
import { Dialog, dialog } from '@forest/shared/react'
import { LoadingOverlay } from './components/loading-overlay'
import { queryClient } from './lib/query-client'
import { mockingReady } from './lib/enable-mocking'
import { m } from './paraglide/messages'
import { native } from '@forest/native-services'
import { failureOf, withFailure } from '@forest/paywall-core'
import { loadingOverlay } from './store/loading-overlay'

void mockingReady.then(render)

function render() {
  createRoot(document.getElementById('root')!).render(
    <StrictMode>
      <ErrorBoundary
        fallbackRender={(props) => <p>{String(props.error)}</p>}
        onError={(error) => {
          native.general.logFatalError({
            name: 'focus-pass:top_level_react_error_boundary',
            reason: String(error),
          })
        }}
      >
        <LoadingOverlay />
        <Dialog />
        <ErrorBoundary
          onError={(error) => {
            const failure = failureOf(error, 'load')
            loadingOverlay.hide()
            dialog.open({
              title: m.dialog_data_load_fail_title(),
              description:
                withFailure(m.dialog_data_load_fail_description(), failure) +
                (import.meta.env.MODE === 'production'
                  ? ''
                  : `\n${String(error)}`),
              button: m.ok(),
              action: () => native.general.close(),
            })
            native.general.logFatalError({
              name: 'focus-pass:app_level_react_error_boundary',
              reason: `${failure.code} | ${String(error)}`,
            })
          }}
          fallback={<></>}
        >
          <QueryClientProvider client={queryClient}>
            <App />
          </QueryClientProvider>
        </ErrorBoundary>
      </ErrorBoundary>
    </StrictMode>,
  )
}
